import React, { Component, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Parkview from "./pages/parkview";
import Index from "./pages/index.js";
import Navibar from "./components/Nav";
import "bootstrap/dist/css/bootstrap.min.css";
import { store } from './app/store'
import { Provider } from 'react-redux'
import HowToExcelView from "./pages/howToUploadExcel";
import WTG from "./pages/wtg";
import OilSensorPage from "./pages/oilSensorPage";

function App() {
    // Version?
    // true == V2
    // false == V1
    const [version, setVersion] = useState(true);

useEffect(() => {
  console.log(version)
}, [version])


    return (
      <Provider store={store}>
        <div
         className="App"
        >
          <Navibar version={version} setVersion={setVersion}/>
          <div>
          <BrowserRouter>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/Parkview" element={<Parkview version={version} />} />
                <Route path="/HowToUploadExcel" element={<HowToExcelView/>}/>
                <Route path="/WTG" element={<WTG/>}/>
                <Route path="/Oilsensor" element={<OilSensorPage/>}/>
              </Routes>
              
          </BrowserRouter>
                </div>
        </div>
      </Provider>
    );
} 
export default App;
